import React from "react";
import {
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import "../Commons/TableTag.css";
import IconEllipsis from "../Icon/Ellipsis.jsx";
class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // render each row details
  createRow = (row) => {
    let keys = Object.keys(row);

    return keys.map((key) => {
      return <td key={key}>{row[String(key)]}</td>;
    });
  };

  formatTime(dateString) {
    if (!dateString) return "N/A";
    var date = new Date(dateString);
    return date.toLocaleDateString();
  }

  render() {
    const heads = this.props.heads;
    const dataAttributes = this.props.dataAttributes;
    const cols = heads.map((head) => (
      <th scope="col" key={head}>
        {head}
      </th>
    ));

    const rows = this.props.rows;
    const data = rows.map((row) => (
      <tr key={row.id}>
        {(function () {
          switch (row["post"]["status"]) {
            case "draft":
              return (
                <td key={`user-${row.id}-status`}>
                  <p className="tag draft-tag">草稿</p>
                </td>
              );
            case "published":
              return (
                <td key={`user-${row.id}-status`}>
                  <p className="tag published-tag">正式發布</p>
                </td>
              );
            case "rejected":
              return (
                <td key={`user-${row.id}-status`}>
                  <p className="tag reject-tag">審核不過</p>
                </td>
              );
            case "approval_pending":
              return (
                <td key={`user-${row.id}-status`}>
                  <p className="tag pending-tag">未審核</p>
                </td>
              );
            default:
              return null;
          }
        })()}
        <td key={`user-${row.id}-title`}>{`${row["post"]["title"]}`}</td>
        <td
          key={`user-${row.id}-display_name`}
        >{`${row["category"]["display_name"]}`}</td>
        <td key={`user-${row.id}-author`}>{`${row["post"]["author"]}`}</td>
        <td key={`user-${row.id}-created_at`}>
          {this.formatTime(row.created_at)}
        </td>
        <td key={`user-${row.id}-author`}>{`${row["post"]["views"]}`}</td>
        <td className="ml-auto" style={{ maxWidth: "50px" }}>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn-icon-only text-light"
              href="#pablo"
              role="button"
              size="sm"
              color=""
              onClick={(e) => e.preventDefault()}
            >
              <IconEllipsis className="size-5" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem
                tag={Link}
                to={"/dash/admin/other-articles/" + row.post.id + "/edit"}
              >
                編輯
              </DropdownItem>
              <DropdownItem
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.remove(row);
                }}
              >
                刪除
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));

    return (
      <OverlayLoading loading={this.props.loading}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>{cols}</tr>
          </thead>
          <tbody>{data}</tbody>
        </Table>
      </OverlayLoading>
    );
  }
}

export default DataTable;
